/**
 * Storage scheme shared by OpfsStorage (writer) and the service worker (reader).
 * MUST stay a DOM-free module so `app/src/sw.ts` (a separate build that cannot
 * import OpfsStorage) can import it too. Changing OFFLINE_NAMESPACE orphans every
 * user's existing cache — bump deliberately.
 */
export const OFFLINE_NAMESPACE = 'offline-v1';

/** Map a normalized resource key to a single flat OPFS filename. */
export const offlineFileName = (key: string): string => encodeURIComponent(key);
